import { httpClient } from '@/shared/api/httpClient';

export type ClienteResumo = {
  id: string;
  nome: string;
  documento: string | null;
  email: string | null;
  telefone: string | null;
  /** Data de aniversário (YYYY-MM-DD) ou null. */
  aniversario: string | null;
  /** true enquanto o cadastro/edição não foi confirmado pelo servidor. */
  syncPendente: boolean;
  /** Quantidade de veículos (não excluídos) ligados ao cliente. */
  quantidadeVeiculos: number;
};

export type CriarClienteRequest = {
  nome: string;
  documento?: string | null;
  email?: string | null;
  telefone?: string | null;
  aniversario?: string | null;
};

export type CriarClienteResponse = { id: string };

export type AtualizarClienteRequest = {
  nome: string;
  /** Ausente = mantém o atual; null = remove o documento. */
  documento?: string | null;
  email: string | null;
  telefone: string | null;
  aniversario?: string | null;
};

export const clientesApi = {
  listar: () => httpClient.get<ClienteResumo[]>('/api/clientes'),
  criar: (cmd: CriarClienteRequest) =>
    httpClient.post<CriarClienteResponse>('/api/clientes', cmd),
  atualizar: (id: string, cmd: AtualizarClienteRequest) =>
    httpClient.put<void>(`/api/clientes/${id}`, cmd),
  excluir: (id: string) => httpClient.delete<void>(`/api/clientes/${id}`),
};
